export default __webpack_public_path__ + "static/media/like.2cf656e5.svg";